import { httpClient } from './api/httpClient';
import { isMockEnabled, mockResponse } from './api/mockAdapter';
import { API_ENDPOINTS } from 'constants/apiEndpoints';
import { STAGE2_STATUS } from 'constants/status';
import { MOCK_STAGE2 } from 'mock/pipeline.mock';

export const toStage2 = (raw) =>
  raw && {
    id: raw.id,
    articleReferenceId: raw.article_reference_id ?? '',
    rootArticleId: raw.root_article_id ?? '',
    currentStage: raw.current_stage ?? 'stage_two',
    workflowState: raw.workflow_state ?? 'active',
    documentVersion: raw.document_version ?? 1,
    status: raw.workflow?.status ?? raw.status ?? 'pending',
    routingDecision: raw.workflow?.routing_destination ?? raw.routing?.destination ?? raw.routing_decision ?? raw.routingDecision ?? 'pending',
    routedByName: raw.routing?.routed_by_name ?? null,
    routedAt: raw.routing?.routed_at ?? null,
    routingHistory: raw.routing_history ?? [],
    notes: raw.routing?.notes ?? raw.notes ?? '',
    newspaperName: raw.newspaper_name ?? raw.newspaperName ?? '',
    edition: raw.edition ?? '',
    keywords: raw.keywords ?? raw.keyword ?? [],
    keyword: raw.keywords ?? raw.keyword ?? [],
    articleTitle: raw.article_title ?? raw.article ?? '',
    article: raw.article_title ?? raw.article ?? '',
    headline: raw.headline ?? '',
    pageNumber: raw.page_number ?? raw.pageNumber ?? null,
    language: raw.language ?? null,
    articleLink: raw.article_image_url ?? raw.article_link ?? raw.articleLink ?? '',
    articleImageUrl: raw.article_image_url ?? null,
    newspaperLink: raw.newspaper_page_image_url ?? raw.newspaper_link ?? raw.newspaperLink ?? '',
    newspaperPageImageUrl: raw.newspaper_page_image_url ?? null,
    mergedPdfUrl: raw.merged_pdf_url ?? null,
    mergedPdfStatus: raw.merged_pdf_status ?? null,
    source: raw.source?.type ?? raw.source ?? '',
    isManualUpload: raw.is_manual_upload ?? false,
    previousStage: raw.previous_stage ?? null,
    workflowTimeline: raw.workflow_timeline ?? [],
    workflow: raw.workflow ?? null,
    createdAt: raw.created_at ?? raw.createdAt ?? null,
  };

let store = MOCK_STAGE2.map((r) => ({ ...r }));

export const stage2Service = {
  async list(params = {}) {
    if (isMockEnabled()) {
      const items = (await mockResponse(store)).map(toStage2);
      return { items, total: items.length, page: 1, pageSize: items.length || 20, totalPages: 1 };
    }
    const data = await httpClient.get(API_ENDPOINTS.STAGE2.LIST, { params });
    return {
      items: (Array.isArray(data) ? data : data.items ?? []).map(toStage2),
      total: data.total ?? 0,
      page: data.page ?? 1,
      pageSize: data.page_size ?? 20,
      totalPages: data.total_pages ?? 0,
    };
  },

  async route(id, { decision, notes, documentVersion }) {
    if (isMockEnabled()) {
      store = store.map((r) =>
        r.id === id
          ? {
              ...r,
              workflow: { ...r.workflow, current_stage: decision, routing_destination: decision, status: STAGE2_STATUS.ROUTED },
              routing: { routed_by: 'mock-user', routed_by_name: 'Mock User', routed_at: new Date().toISOString(), notes: notes || '' },
            }
          : r
      );
      return toStage2(await mockResponse(store.find((r) => r.id === id)));
    }
    return toStage2(
      await httpClient.post(API_ENDPOINTS.STAGE2.ROUTE(id), {
        destination: decision,
        notes,
        document_version: documentVersion,
      })
    );
  },

};

export default stage2Service;
